function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneRing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_71_2417)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7438 25.3094C18.6469 25.3094 17.3876 25.025 16.0063 24.4969C13.2438 23.4 10.1969 21.2875 7.47506 18.5656C4.75318 15.8437 2.64068 12.7969 1.54381 9.99373C0.325055 6.98748 0.44693 4.50936 1.86881 3.12811C1.90943 3.08748 1.99068 3.04686 2.03131 3.00623L5.44381 0.974984C6.29693 0.487484 7.39381 0.731234 7.96256 1.54373L10.3594 5.11873C10.9282 5.97186 10.6844 7.10936 9.87193 7.67811L8.40943 8.69373C9.46568 10.4 12.4719 14.5844 17.2657 17.5906L18.1594 16.2906C18.8501 15.3156 19.9469 15.0312 20.8407 15.6406L24.4157 18.0375C25.2282 18.6062 25.4719 19.7031 24.9844 20.5562L22.9532 23.9687C22.9126 24.05 22.8719 24.0906 22.8313 24.1312C22.1001 24.9031 21.0438 25.3094 19.7438 25.3094ZM3.08756 4.50936C2.31568 5.36248 2.35631 7.10936 3.25006 9.34373C4.26568 11.9031 6.21568 14.7062 8.77506 17.2656C11.2938 19.7844 14.1376 21.7344 16.6563 22.75C18.8501 23.6437 20.5969 23.6844 21.4907 22.9125L23.4407 19.5812C23.4407 19.5406 23.4407 19.5406 23.4407 19.5L19.8657 17.1031C19.8657 17.1031 19.7844 17.1437 19.7032 17.2656L18.8094 18.5656C18.2407 19.3781 17.1438 19.6219 16.3313 19.0937C11.2126 15.925 8.04381 11.4969 6.90631 9.70936C6.37818 8.85623 6.58131 7.75936 7.39381 7.19061L8.85631 6.17498V6.13436L6.45943 2.55936C6.45943 2.51873 6.41881 2.51873 6.37818 2.55936L3.08756 4.50936Z",
    fill: "#3674CB",
    style: {
      fill: "#3674CB",
      fill: "color(display-p3 0.2118 0.4549 0.7961)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8071 11.5781C23.3196 11.5781 22.954 11.2125 22.9134 10.725C22.5884 6.62187 19.2165 3.33125 15.0727 3.04687C14.5852 3.00625 14.179 2.6 14.2196 2.07187C14.2602 1.58437 14.6665 1.17812 15.1946 1.21875C20.2321 1.54375 24.3352 5.525 24.7415 10.5625C24.7821 11.05 24.4165 11.4969 23.8884 11.5375C23.8884 11.5781 23.8477 11.5781 23.8071 11.5781Z",
    fill: "#3674CB",
    style: {
      fill: "#3674CB",
      fill: "color(display-p3 0.2118 0.4549 0.7961)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7847 11.9438C19.3378 11.9438 18.9316 11.6188 18.891 11.1313C18.6472 8.93756 16.941 7.23131 14.7472 6.94693C14.2597 6.90631 13.8941 6.41881 13.9347 5.93131C13.9753 5.44381 14.4628 5.07818 14.9503 5.11881C17.9972 5.48443 20.3535 7.84068 20.7191 10.8876C20.7597 11.3751 20.4347 11.8219 19.9066 11.9032C19.8253 11.9438 19.7847 11.9438 19.7847 11.9438Z",
    fill: "#3674CB",
    style: {
      fill: "#3674CB",
      fill: "color(display-p3 0.2118 0.4549 0.7961)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_71_2417"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneRing);
export default __webpack_public_path__ + "static/media/phone-ring.04ded409950803f60fa4de1995cd9850.svg";
export { ForwardRef as ReactComponent };